import { AppIcon, AppText } from "@toothfairy/shared-ui";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { ScrollView, TouchableOpacity, View } from "react-native";

const AgentBuilderSidebar = ({
  groups,
  activeSection,
  onSelect,
  errorSections = [],
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const primary = currentTheme?.theme?.primary;

  return (
    <View
      style={{
        width: 230,
        minWidth: 230,
        borderRightWidth: 1,
        borderRightColor: currentTheme?.theme?.lightGrey,
        backgroundColor: currentTheme?.theme?.backgroundColor,
        height: "100%",
      }}
    >
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{ paddingVertical: 12, paddingHorizontal: 10 }}
        showsVerticalScrollIndicator={false}
      >
        {groups?.map((group) => {
          if (!group?.items?.length) return null;
          return (
            <View key={group.id} style={{ marginBottom: 14 }}>
              <AppText
                style={{
                  fontSize: 11,
                  letterSpacing: 0.6,
                  textTransform: "uppercase",
                  marginBottom: 6,
                  marginLeft: 10,
                }}
                color={currentTheme?.theme?.mediumGrey}
                fontWeight="600"
              >
                {group.label}
              </AppText>
              {group.items.map((item) => {
                const isActive = item.id === activeSection;
                return (
                  <TouchableOpacity
                    key={item.id}
                    onPress={() => onSelect(item.id)}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      paddingVertical: 9,
                      paddingHorizontal: 12,
                      borderRadius: 10,
                      marginBottom: 2,
                      backgroundColor: isActive
                        ? primary
                        : currentTheme?.theme?.transparent,
                    }}
                  >
                    {item.icon && (
                      <AppIcon
                        icon={item.icon}
                        size={15}
                        color={
                          isActive
                            ? currentTheme?.theme?.white
                            : currentTheme?.theme?.darkGrey
                        }
                        style={{ marginRight: 9 }}
                      />
                    )}
                    <AppText
                      style={{ fontSize: 13, flexShrink: 1 }}
                      numberOfLines={1}
                      color={
                        isActive
                          ? currentTheme?.theme?.white
                          : currentTheme?.theme?.textColor
                      }
                      fontWeight={isActive ? "600" : "normal"}
                    >
                      {item.title}
                    </AppText>
                    {errorSections?.includes(item.id) && (
                      <View
                        style={{
                          width: 7,
                          height: 7,
                          borderRadius: 4,
                          backgroundColor: currentTheme?.theme?.red,
                          marginLeft: "auto",
                          flexShrink: 0,
                        }}
                      />
                    )}
                  </TouchableOpacity>
                );
              })}
            </View>
          );
        })}
      </ScrollView>
    </View>
  );
};

export default AgentBuilderSidebar;
